
import { v4 as uuidv4 } from 'uuid';

const addUuidToObject = (obj: any) => {
  if (!obj._id) {
    obj._id = uuidv4();
  }
  return obj;
}

// Primjer dodavanja UUID-a u rezultate upita
export const processQueryResult = (result:any) => {
  if (result.data && result.data.health) {
    result.data.health = addUuidToObject(result.data.health);
  }
  return result;
}